import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { Jalur } from "@/types";
import api from "@/lib/axios";
import SkeletonTable from "@/components/SkeletonTable";

export interface JalurResponse {
  data: Jalur[];
}

const getListJalurGroup = async () => {
  const response = await api.get("/master/jalur-grup/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export default function MasterJalurGroupPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJalurGroup"],
    queryFn: getListJalurGroup,
    retry: false,
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  );
}
